"use strict";

const staticData = require("client/static_data");

/**
 * Constructable stylesheets — `new CSSStyleSheet()` plus `ShadowRoot.adoptedStyleSheets` —
 * are how every design-system component styles its shadow DOM. Safari exposes the
 * `CSSStyleSheet` interface long before its constructor becomes usable, so probing
 * the interface is not enough: build a sheet for real.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleSheet/CSSStyleSheet
 */
function _supportsConstructableStyleSheets () {
    if (typeof ShadowRoot === "undefined" || !("adoptedStyleSheets" in ShadowRoot.prototype)) {
        return false;
    }
    try {
        return typeof new CSSStyleSheet().replaceSync === "function";
    } catch (e) {
        return false;
    }
}

/**
 * If the js file was loaded in the "nojs" page, redirect to the default page.
 * Likely the page was reloaded, after enabling js in the browser.
 */
if (window.location.href.includes("nojs")) {
    window.location = `${staticData.base_url}/${staticData.lang}/bicsearch`;
    return;
}

/**
 * if you are not already in the "unsupported" page and webcomponent are not supported
 * by the browser, redirect to the "unsupported" page.
 */
if (!window.location.href.includes("unsupported") && !window.customElements) {
    window.location = `${staticData.base_url}/${staticData.lang}/unsupported`;
    return;
}

/**
 * if you are not already in the "unsupported" page and the browser cannot
 * construct stylesheets (Safari < 16.4, Firefox < 101, Chrome < 73), redirect to
 * the "unsupported" page: the design-system components throw
 * "TypeError: Illegal constructor" while the bundle is evaluated.
 */
if (!window.location.href.includes("unsupported") && !_supportsConstructableStyleSheets()) {
    window.location = `${staticData.base_url}/${staticData.lang}/unsupported`;
    return;
}

require("client/style/index.css");

// import shared modules
require("client/error_logger.js");
require("client/static/nubilaria_logo.svg");
require("client/static/page_not_found.svg");
// the world map: emitted as a static asset and injected by client/world_map.js
// on the pages that only decorate with it
require("client/static/world_map.svg");
require("client/static/favicon.ico");
require("client/mobile_nav.js");

// import design system components
require("website_design_system/public_pages_index.js");


// function _changeTab (event) {
//     const tabName = event.detail.name;
//     window.location = `${staticData.base_url}/${staticData.lang}/${tabName}`;
// }
//
// const header = document.querySelector("swiftref-header");
// if (header) {
//     header.addEventListener("change_tab", _changeTab);
// }
// const tabs = document.querySelector("swiftref-tabs");
// if (tabs) {
//     tabs.addEventListener("change_tab", _changeTab);
// }

//=====================
// The external world map: inject the SVG after the first paint so the document
// stays free of the ~96 KiB markup (report §10.9). On ibanvalidation there is no
// `[data-map-src]` placeholder (the map stays inline, its paths are coloured by
// client/pages/ibanvalidation/map.js), so this is a no-op there.
//=====================
const worldMap = require("client/world_map");
if (document.readyState === "complete") {
    worldMap.load();
} else {
    window.addEventListener("load", worldMap.load);
}
